<template>
    <div class="benefits">
        <div class="container benefits__grid">
            <div class="benefits__item">
                <svg class="benefits__icon benefits__icon--healthcheck">
                    <path d="M44.2 7.3h-1.9v-2c0-.9-.8-1.7-1.8-1.7H11v-1C11 1.3 9.7 0 8.2 0a2.7 2.7 0 0 0-2.7 2.7v1H1.8c-1 0-1.8.7-1.8 1.7v47.2c0 1 .8 1.8 1.8 1.8h1.9v1.8c0 1 .8 1.8 1.8 1.8h38.7c1 0 1.8-.8 1.8-1.8V9c0-1-.8-1.7-1.8-1.7Zm-37-4.6c0-.6.5-1 1-1 .6 0 1 .4 1 1v1h-2v-1Zm37 53.5v.1H5.5v-2h35c1 0 1.8-.7 1.8-1.7v-39c0-.5-.4-.9-.9-.9-.4 0-.8.4-.8.9v39H1.7V5.4h3.7V8c0 1.5 1.2 2.7 2.7 2.7C9.7 10.8 11 9.6 11 8c0-.5-.3-.8-.8-.8s-.9.3-.9.8-.4 1-1 1a1 1 0 0 1-1-1V5.3h33.3V10c0 .5.5.9 1 .9.4 0 .8-.4.8-.9V9h2v47.3Z" />
                    <path d="M34.5 33H16c-.4 0-.8.3-.8.8 0 .4.4.7.8.7h18.5c.5 0 .9-.3.9-.8 0-.4-.4-.7-.9-.7Zm-23.2 0H8.5c-.5 0-1 .3-1 .8 0 .4.5.7 1 .7h2.8c.4 0 .8-.3.8-.8 0-.4-.4-.7-.8-.7Zm23.2 5H16c-.4 0-.8.3-.8.8 0 .4.4.7.8.7h18.5c.5 0 .9-.3.9-.8 0-.4-.4-.7-.9-.7Zm0 5.5H16c-.4 0-.8.3-.8.8 0 .4.4.7.8.7h18.5c.5 0 .9-.3.9-.8 0-.4-.4-.7-.9-.7ZM11.3 38H8.5c-.5 0-1 .3-1 .8 0 .4.5.7 1 .7h2.8c.4 0 .8-.3.8-.8 0-.4-.4-.7-.8-.7Zm0 5.5H8.5c-.5 0-1 .3-1 .8 0 .4.5.7 1 .7h2.8c.4 0 .8-.3.8-.8 0-.4-.4-.7-.8-.7Z" />
                    <path d="M30 19.7h-1.6c.7-1.5.6-2.8.3-3.6a4.2 4.2 0 0 0-4-3.1c-.7 0-1.3.1-1.9.3l-2 1-2-1L17 13a4.3 4.3 0 0 0-4.1 3.1c-.3.9-.4 2.2.5 4h-2c-.2 0-.3 0-.3.2s.1.3.3.3h2.3l.4.5c1.9 2.7 6 5.7 6.7 5.9h.1a23.2 23.2 0 0 0 7.2-6.7h2l.2-.3c0-.2-.1-.3-.3-.3Zm-3 1a22.3 22.3 0 0 1-6.2 5.7c-.8-.5-4.3-2.8-6.3-5.6v-.2H17l.3-.1 1.2-2.4 2 4.8c0 .2 0 .2.2.2.1 0 .3 0 .3-.2l1.7-5.7.9 2.9s0 .2.2.2c.1 0 .2 0 .3-.2l.7-1 .6 1 .3.2h1.6l-.3.5Zm.7-1H26l-.7-1.3-.3-.1-.2.1-.6 1-1-3.3c0-.2-.2-.2-.3-.2-.2 0-.3 0-.3.2l-1.7 5.8-1.9-4.7-.2-.2c-.1 0-.2 0-.3.2L17 20h-3c-.7-1.3-.9-2.6-.5-3.7a3.7 3.7 0 0 1 3.5-2.7l1.6.3c1.3.5 2 1 2 1 .1.1.3.1.4 0 0 0 .7-.5 2-1l1.6-.3c2 0 3.2 1.4 3.6 2.7.3 1 .1 2.2-.5 3.4Z" />
                </svg>
                <h2 class="benefits__title">3 Year Manufacturer Warranty</h2>
                <p>
                    To give you that extra peace of mind when buying your new car from
                    Stellantis &You UK, all our new cars in stock come with a 3 year
                    manufacturer warranty included.
                </p>
            </div>

            <div class="benefits__item">
                <svg class="benefits__icon benefits__icon--vehicle-check">
                    <path d="M78.24 29.42a17 17 0 1 1 0 34 17 17 0 0 1 0-34Zm0 2a15 15 0 1 0 0 30 15 15 0 0 0 0-30ZM59.9 0h.25a6 6 0 0 1 5.08 3.24l7.19 13.86h10.2v5.45a5 5 0 0 1-3.45 4.75l-3.03 1-.62-1.9 3.03-1 .17-.06a3 3 0 0 0 1.9-2.79V19.1H71.2l-.28-.54-7.47-14.4A4 4 0 0 0 59.91 2h-37.2a4 4 0 0 0-3.55 2.16l-7.47 14.4-.28.54H2v3.45a3 3 0 0 0 1.9 2.8l.16.05 3.04 1 .66.22.02.7.83 24.61a3 3 0 0 0 3 2.9h4.08a3 3 0 0 0 3-3v-3.51H14.9v-2h44.34v2H20.7v3.5a5 5 0 0 1-5 5H11.6a5 5 0 0 1-5-4.82l-.8-23.92-2.37-.78A5 5 0 0 1 0 22.78V17.1h10.2l7.19-13.86A6 6 0 0 1 22.46 0l.25-.01h37.2ZM86.5 40.7l1.46 1.36L77 53.78l-.75.8-.73-.82-6-6.68L71 45.75l5.28 5.86L86.5 40.7ZM54.24 30.42l-.8 7.22a2 2 0 0 1-2 1.78H31.04a2 2 0 0 1-1.99-1.78l-.8-7.22h26Zm-34.6-1a7 7 0 0 1 7 7v3H12.1v-2h12.55v-1a5 5 0 0 0-4.78-5H12.1v-2h7.55Zm46.13 0v2h-2.88a5 5 0 0 0-4.79 5v1h2.46v2H56.1v-3a7 7 0 0 1 7-7h2.67Zm-13.77 3H30.47l.56 5h20.42l.55-5Zm4.37-26a5 5 0 0 1 4.32 2.48l5.55 9.52h-50l5.55-9.52a5 5 0 0 1 4.32-2.48h30.26Zm0 2H26.1a3 3 0 0 0-2.59 1.48l-3.8 6.52h43.04l-3.8-6.52a3 3 0 0 0-2.4-1.48h-.2Z" />
                </svg>
                <h2 class="benefits__title">Price Match Promise</h2>
                <p>
                    Our price match promise guarantees to beat any like for like written
                    quotation from any other franchised dealership.
                </p>
            </div>

            <div class="benefits__item">
                <svg class="benefits__icon benefits__icon--technician">
                    <path d="M26.4 1.5c5.7 0 9 1.5 10.8 4.2 1.4 2 2 4.5 2.2 7.3.2 1.6.2 3.2.2 4.8 0 4.7-1.6 8.3-3.7 11a14 14 0 0 1-9.5 5.3 14 14 0 0 1-9.4-5.4 16.9 16.9 0 0 1-3.7-10.9c0-1.6 0-3.2.2-4.7.2-3 .7-5.5 2.2-7.4 2-2.7 5.3-4.2 10.7-4.2Z" />
                    <path d="m31 7-1 2.7c-2.6-.8-4.5-.8-7 0-.5-1-.7-1.6-1-2.6 3.2-1 5.7-1 9 0Zm-18.3 7.7c.2.5 1 2 2.2 2.2 1.4.2 3.8-5.1 11.5-5.1 7.8 0 10.2 5.3 11.6 5.1 1.2-.1 2-1.7 2.2-2.2 0 1 2.7-14-13.8-14-16.4 0-13.7 15-13.7 14Zm4.9 19.2c2 1.3 3.7 2.1 5.7 2.5l2.7 6.7 2.6-6.5c2-.6 3.9-1.4 5.5-2.7 3.3 1.5 10.3 5.2 12.3 6.5 2.8 1.9 4.1 7.1 4.8 11.2-.2.7-1.4 2.9-5.7 4.8h-.1l.1-.1.3-.4.2-.2a3.4 3.4 0 0 0 0-3.4 9.2 9.2 0 0 0-15-1H21a9.2 9.2 0 0 0-15 1 3.4 3.4 0 0 0 .6 4.1h-.2C2.6 54.5 1.3 52.7.9 52c.2-2.3 1.5-9.5 4.7-11.6 1-.6 3-1.8 5.4-3l.6-.4.8-.4 5.2-2.7Z" />
                    <path d="M43.6 59.2h-5.2c-.1-.2-.3-.8-.3-2.3 0-1.4.2-2 .3-2.3h5.2a.4.4 0 0 0 .3-.5 5.9 5.9 0 0 0-10.6.6H19.6A5.9 5.9 0 0 0 9 54.1a.4.4 0 0 0 .3.5h5.2c.1.2.3.9.3 2.3 0 1.5-.2 2-.3 2.3H9.3a.4.4 0 0 0-.3.5c1 1.9 3 3 5.1 3a5.8 5.8 0 0 0 5.5-3.6h13.7a6 6 0 0 0 5.5 3.6c2.1 0 4-1.1 5-3a.4.4 0 0 0-.2-.5Z" />
                </svg>
                <h2 class="benefits__title">Manufacturer Approved Servicing</h2>
                <p>
                    With dealerships available nationwide, when the time comes for your
                    annual service you can visit a Stellantis &You UK dealership near you.
                    With many years’ experience and factory-trained technicians, you'll
                    get an excellent and affordable, service, MOT or repair.
                </p>
            </div>

            <div class="benefits__item">
                <svg class="benefits__icon benefits__icon--money-back">
                    <path d="M28.15 28.22v-7.24c0-1.3.42-2.3 1.25-2.96.83-.68 2.1-1.01 3.78-1.01a12.49 12.49 0 0 1 2.73.32v2.11a10.32 10.32 0 0 0-2.57-.34 5.5 5.5 0 0 0-1.56.18 1.5 1.5 0 0 0-.85.57c-.17.26-.26.6-.26 1.03v7.34h-2.52Zm-1.57.78v-2.07h9.68V29h-9.68Zm0-5.06v-1.88h7.8v1.88h-7.8Z" />
                    <path d="M30.14 8C38.89 8 46 14.93 46 23.5S38.9 39 30.14 39a16 16 0 0 1-11.64-4.96 1 1 0 0 1 1.45-1.38A14 14 0 0 0 30.14 37C37.8 37 44 30.95 44 23.5S37.8 10 30.14 10c-6.06 0-11.35 3.8-13.2 9.32a1 1 0 1 1-1.89-.64A15.84 15.84 0 0 1 30.14 8Zm.36-8C43.47 0 54 10.3 54 23a1 1 0 0 1-2 0c0-11.6-9.62-21-21.5-21C18.69 2 9.1 11.3 9 22.8c.02.07.02.13.02.2a1 1 0 0 1-1 1H5.84l7.25 11.15L20.18 24H13.1a1 1 0 0 1-.99-.88V23a1 1 0 0 1 1-1h10.71l-.98 1.54-8.9 14-.83 1.3-.84-1.3-9.1-14L2.15 22h4.86C7.56 9.76 17.87 0 30.5 0Zm26.38 44.9a5.07 5.07 0 0 1-1.3 4.58c-1.13 1.13-7.35 5.37-18.93 12.94a11 11 0 0 1-8.77 1.45L16.05 60.8a8.52 8.52 0 0 0-6.53.95 1 1 0 1 1-1.04-1.72 10.52 10.52 0 0 1 8.07-1.17l11.83 3.06a9 9 0 0 0 7.18-1.18c11.33-7.4 17.63-11.7 18.62-12.69.64-.63.97-1.79.75-2.7-.22-.94-.96-1.45-2.38-1.35-2.52.18-5.83 2-9.87 5.52a1 1 0 1 1-1.31-1.51c4.33-3.77 7.99-5.79 11.03-6 2.39-.17 4.02.97 4.48 2.88ZM16.75 42l19.3 5.5a4.72 4.72 0 0 1 3.34 5.37 4.15 4.15 0 0 1-5.07 3.3l-10.99-2.72a1 1 0 1 1 .48-1.94l10.99 2.71a2.15 2.15 0 0 0 2.63-1.7 2.72 2.72 0 0 0-1.94-3.1l-19.29-5.5a7 7 0 0 0-5.53.73l-9.15 5.51a1 1 0 1 1-1.04-1.71l9.16-5.51a9 9 0 0 1 7.11-.95Z" />
                </svg>
                <h2 class="benefits__title">Hassle-free Part-exchange</h2>
                <p>
                    We’ve made it easy to part-exchange your vehicle. Get a free, instant
                    valuation by using our handy valuation tool powered by Auto Trader.
                    When you arrive on site, one of our sales advisors will take a look
                    around the vehicle to confirm it matches your valuation price.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "../../../../sass/redesign/variables";

.benefits {
    margin-top: 30px;
    padding-top: 60px;
    padding-bottom: 60px;
    background-color: $light-blue;

    &__grid {
        display: grid;
        gap: 15px;

        @media (min-width: $screen-md) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }

    &__title {
        color: $dark-blue;
        font-size: 16px;
        line-height: 18px;
    }

    &__icon {
        fill: $blue;
        margin-bottom: 15px;

        &--warranty {
            width: 42.99px;
            height: 64px;
        }

        &--healthcheck {
            width: 46px;
            height: 64px;
        }

        &--vehicle-check {
            width: 95.24px;
            height: 64px;
        }

        &--right-price {
            width: 63px;
            height: 64px;
        }

        &--money-back {
            width: 57px;
            height: 64px;
        }

        &--technician {
            width: 52px;
            height: 64px;
            fill: none;
            stroke: $blue;
            stroke-width: 1.5px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/new-vue/components/details/Benefits.vue